import {APP, GET_8_PIXEL_BOX} from '../../style/variable';

export default {
  root: {
    outline: '0 !important'
  },
  contained: {
    '&:hover': {
      boxShadow: 'none'
    },
    boxShadow: 'none',
    backgroundColor: '#FFFFFF',
    borderRadius: `${GET_8_PIXEL_BOX(0.5)}`,
    outline: '0 !important',
    fontSize: '1.06rem',
    fontFamily: `${APP.FONT_FAMILY.REGULAR}, Verdana, Tahoma, sans-serif !important`,
    textTransform: 'none'
  },
  outlined: {
    textTransform: 'none'
  },
  text: {
    textTransform: 'none'
  }
};
